import { getChatUserIdFromIdentity } from '../../features/realtime/realtime.helpers';
import {
  type RealtimeMember,
  RealtimeState,
} from '../../features/realtime/realtime.types';

/**
 * User who is waiting for a call.
 *
 * This can be either:
 * - patient who has checked into the waiting room and is waiting for the provider to invite them to the call,
 * - or provider who is shown in the patient's waiting room, regardless of whether the provider is currently online
 *   (in which case realtime data is used) or offline (in which case default data is used).
 */
export type WaitingMember = RealtimeMember & {
  id: string;
  chatUserId: string;
  joinedAt: number;
  state: Omit<RealtimeState, 'username'> & { username: string };
};

export const getWaitingMember = (
  realtimeMember: RealtimeMember,
): WaitingMember => ({
  ...realtimeMember,
  id: realtimeMember.identity.id,
  chatUserId: getChatUserIdFromIdentity(realtimeMember.identity),
  joinedAt: realtimeMember.state.checkedInAt as number,
  state: {
    ...realtimeMember.state,
    username: realtimeMember.state.username ?? '',
  },
});
